import { connect } from 'react-redux';

import { GridActionsMenu, GridActionsMenuProps } from '../../components/GridActionsMenu/GridActionsMenu';
import { pricePackagesMenuActionsSelector } from '../../selectors/pricePackages/pricePackages';
import { Bem } from '../../service/Bem/Bem';
import { PricePackagesMenuActions } from '../../typings/pricePackages';
import { State } from '../../typings/state';

export interface PricePackagesMenuActionsContainerProps {
    index: number;
    actions: PricePackagesMenuActions;
}

const mapStateToPropsForGrid = (
    state: State,
    ownProps: PricePackagesMenuActionsContainerProps
): GridActionsMenuProps => {
    const { actions, events } = pricePackagesMenuActionsSelector(state, ownProps);

    return {
        actions,
        events,
        cls: Bem.cls('price-packages-menu-actions')
    };
};

const mergeProps = (stateProps: GridActionsMenuProps): GridActionsMenuProps => {
    return stateProps;
};

export const PricePackagesMenuActionsContainer = connect<
    GridActionsMenuProps,
    {},
    PricePackagesMenuActionsContainerProps,
    GridActionsMenuProps
>(
    mapStateToPropsForGrid,
    undefined,
    mergeProps
)(GridActionsMenu);
